<template>
    <div>
        <transition name="modal" v-if="carregando">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
                        <label>Aguarde. Carregando.</label>
                    </div>
                </div>
            </div>
        </transition>
        <div v-else>
            <div v-if="erro">
                <div>
                    <SemPermissao></SemPermissao>
                </div>
            </div>
            <template v-if="!erro">
                <FormularioForm :formulario="formulario" />
            </template>
        </div>
    </div>
</template>

<script>

    import FormularioForm from "../../components/formularios/FormularioForm.vue"
    import FormularioApi from "../../services/FormularioApi"
    import SemPermissao from "../SemPermissao.vue"
    import metaDados from "../../helpers/metaDados";

    export default {
        name: "FormularioEdit",
        metaInfo() {
            if (!this.formulario) {
                return {};
            }
            let title = this.formulario.texto;
            const description = this.formulario.texto;

            return {
                title,
                titleTemplate: "Editar %s - Casa Civil do Estado de Goiás",
                meta: [
                    {
                        vmid: "description",
                        name: "description",
                        property: "description",
                        content: description,
                    },
                    {
                        vmid: "og:description",
                        property: "og:description",
                        content: description,
                    },
                    {
                        vmid: "og:title",
                        property: "og:title",
                        content: `${title} - Casa Civil do Estado de Goiás`,
                    },
                    ...metaDados(this.$route),
                ],
            };
        },
        data() {
            return {
                carregando: true,
                erro: false,
                formulario: null,
            };
        },
        components: {
            SemPermissao,
            FormularioForm,
        },
        created() {
            this.formularioApi = new FormularioApi();
            this.carregarFormulario();
        },
        watch: {
            $route: function (to, from) {
                if (to.params.id != from.params.id) {
                    this.carregarFormulario();
                }
            },
        },
        methods: {
            carregarFormulario: async function () {
                try {
                    this.carregando = true;
                    this.erro = false;

                    if (this.formularioApi.cancelTokens.getFormulario) {
                        this.formularioApi.cancelTokens.getFormulario.cancel();
                    }

                    const dadosFormulario = await this.formularioApi.getFormulario(
                        this.$route.params.id
                    );
                    this.formulario = dadosFormulario;

                    this.carregando = false;
                } catch (err) {
                    if (this.formularioApi.isCancel(err)) {
                        return;
                    }
                    console.log(err);

                    this.erro = true;
                    this.carregando = false;
                    this.formulario = null;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
/* Seus estilos podem ser mantidos aqui */
</style>